/**
 * @param statementId - the statement ID that was used to generate the gap analysis report
 * @returns the {@link StatementSelectionLogic} required to link to the Performances table using
 * a {@link PerformancesTableButton}
 */
export const getGapAnalysisStatementSelectionLogic = (
    statementId: Maybe<string>,
): StatementSelectionLogic => {
    if (statementId) {
        return {
            type: 'statementRange',
            statementRange: {
                statementIdEnd: statementId,
            },
        };
    }

    return {
        type: 'presetsWithRegion',
        presetsWithRegion: {
            primary: 'all_domestic',
            fallback: 'all_international',
        },
    };
};
